import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { instanceOf } from 'prop-types';
import React, { Component } from 'react';
import { Modal as HeaderModal } from 'react-bootstrap';
import { Cookies, withCookies } from 'react-cookie';
import image from '../../Assets/images/commonImages/logo.svg';
import profile from '../../Assets/images/commonImages/profile.svg';
import { globalVal } from '../../global/globalvalues';
import './simpleHeader.scss';
import mweb_profile from '../../Assets/images/commonImages/mweb_profileIcon.svg';
import arrow from '../../Assets/images/commonImages/arw.svg';
import TagManager from 'react-gtm-module';
import { returnName } from '../../global/commonFunctions/getUserName';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';

type initialState = {
    anchorEl: any;
    isModal: boolean;
    isUserNameClicked: boolean;
};
type initialProps = { history: any; middleContent?: string; user?: any; isHelp?: boolean; cookies: any };

export class simpleHeader extends Component<initialProps, initialState> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };
    state = { anchorEl: null, isModal: false, isUserNameClicked: false };

    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
        });
    };
    // GAAndFBEventsHandler =(buttonVal: string) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //     });
    //   };

    handleLogout = () => {
        localStorage.clear();
        const { cookies } = this.props;
        cookies.remove('astoundAccessToken');
        window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGOUT_URL}`;
        // this.props.history.push('/mobile-login');
        // this.GAAndFBEventsHandler("Logout")
        TagManager.dataLayer({
            dataLayer: {
              event: "Logout",
            },
          });
    };

    openModal = () => {
        this.setState({
            isModal: true,
        });
    };
    onHide = () => {
        this.setState({ isModal: false, isUserNameClicked: false });
    };
    render() {
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        return (
            <div className="simpleHeaderMain">
                <AppBar position="fixed" className="headerContent">
                    <div className="headerInnerDiv">
                        <div onClick={() => this.props.history.push('/')}>
                            <img
                                className="headerLogo"
                                src={globalVal && globalVal.logo ? globalVal.logo : image}
                                alt="Astound mobile logo"
                            />
                        </div>
                        <div className="middleDiv">{this.props.middleContent}</div>

                        <div className="lastDiv">
                            {this.props.isHelp && (
                                <div className="help" onClick={() => {
                                    this.props.history.push('/help')
                                    // this.GAAndFBEventsHandler("Help")
                                    TagManager.dataLayer({
                                        dataLayer: {
                                          event: "Help",
                                        },
                                      });
                                }}>
                                    Support
                                </div>
                            )}
                            {this.props.user && (
                                <div>
                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        className={
                                            this.state.anchorEl ? 'clickedHeaderTab fontStyleHeader' : 'fontStyleHeader'
                                        }
                                        // onMouseOver={this.handleClick}
                                        onClick={this.handleClick}
                                    >
                                        <div className="innerLast">
                                            <img src={profile} alt="userIcon" />
                                            <div className="name username">
                                                {`${customerDetail?.firstName ? returnName(customerDetail, "firstName") : ''}` + ' ' + `${customerDetail?.lastName ? returnName(customerDetail, "lastName") : ''}`}
                                            </div>
                                        </div>
                                    </Button>
                                    <Menu
                                        id="simple-menu"
                                        className="SimpleHeaderDropdown"
                                        anchorEl={this.state.anchorEl}
                                        keepMounted
                                        open={Boolean(this.state.anchorEl)}
                                        // MenuListProps={{ onMouseLeave: this.handleClose }}
                                        // MenuListProps={{ onMouseClick: this.handleClose }}
                                        onClose={this.handleClose}
                                    >
                                        {this.props.isHelp ? null : (
                                            <MenuItem
                                                className="menuitemHeader"
                                                // onClick={() =>
                                                //     window.open('https://learn.reachmobile.com/en', '_blank')
                                                // }
                                            >
                                                HELP
                                            </MenuItem>
                                        )}
                                        <MenuItem
                                            className="menuitemHeader"
                                            onClick={() => this.props.history.push('/profile')}
                                        >
                                            Profile
                                        </MenuItem>
                                        <MenuItem className="menuitemHeader" onClick={() => this.handleLogout()}>
                                            Log out
                                        </MenuItem>
                                    </Menu>
                                </div>
                            )}
                        </div>
                    </div>
                </AppBar>

                <AppBar position="fixed" className="headerContentMobile">
                    <div className="headerContentMobileinner">
                        <div onClick={() => this.props.history.push('/')}>
                            <img
                                className="headerLogoMobile"
                                src={globalVal && globalVal.logo ? globalVal.logo : image}
                                alt="Astound mobile logo"
                            />
                        </div>
                        <div>
                            <MenuIcon
                                style={{
                                    color: 'var(--primary_color1)',
                                    width: '45px',
                                    height: '51px',
                                    padding: '0px 0px 0px 15px',
                                    marginRight: '12px',
                                }}
                                onClick={this.openModal}
                            />
                        </div>
                    </div>
                </AppBar>
                <HeaderModal
                    show={this.state.isModal}
                    onHide={() => this.onHide()}
                    size={'xl'}
                    className="modalMainSimpleHeader"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <div className="modalLogo">
                        <div onClick={() => this.props.history.push('/')}>
                            <img
                                className="headerLogo"
                                width={145}
                                height={70}
                                src={globalVal && globalVal.logo ? globalVal.logo : image}
                                alt="Astound mobile logo"
                            />
                        </div>
                        <CloseIcon className="closeIcon" onClick={() => this.onHide()} />
                    </div>
                    <div className="bottomContent">
                        <div className="innerLast">
                            {!this.state.isUserNameClicked && (
                                <div className="menuItems" onClick={() => {
                                    this.props.history.push('/help')
                                    // this.GAAndFBEventsHandler("Help")
                                    TagManager.dataLayer({
                                        dataLayer: {
                                          event: "Help",
                                        },
                                      });
                                }}>
                                    Support
                                    <img src={arrow} alt="arrow" className="navArrowIcon" />
                                </div>
                            )}
                            {this.props.user && (
                                <div
                                    className={
                                        this.state.isUserNameClicked ? 'menuItems secUserName' : 'menuItems userName'
                                    }
                                    onClick={() => this.setState({ isUserNameClicked: true })}
                                >
                                    <div>
                                        <img className="mwebProfileIcon" src={mweb_profile} alt="mweb_profile" />
                                        <span className='username'>{this.props.user.firstName + ' ' + this.props.user.lastName}</span>
                                    </div>
                                    {!this.state.isUserNameClicked && (
                                        <img src={arrow} alt="arrow" className="navArrowIcon" />
                                    )}
                                </div>
                            )}
                            {this.state.isUserNameClicked && (
                                <div className="greyBgColor">
                                    <div
                                        className="menuItems secMenuItems"
                                        onClick={() => this.props.history.push('/profile')}
                                    >
                                        Profile
                                        <img src={arrow} alt="arrow" className="navArrowIcon" />
                                    </div>
                                    <div className="menuItems secMenuItems" onClick={() => this.handleLogout()}>
                                        Log out
                                        <img src={arrow} alt="arrow" className="navArrowIcon" />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </HeaderModal>
            </div>
        );
    }
}

export default withCookies(simpleHeader);
